import React, {
  Fragment,
  useState,
  useEffect,
  useMemo,
  useContext,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//import qs from 'qs';
import { SettingsContext } from './index';
import Step from './components/shared/Step';
import StepOne from './components/StepOne';
import StepTwo from './components/StepTwo';
//import Specializations from './components/specializations/Specializations';
import RoomUpgrades from './components/extras/RoomUpgrades';
//import Essentials from './components/extras/Essentials';
import Excursions from './components/extras/Excursions';
import Gears from './components/extras/Gears';
import Upsells from './components/extras/Upsells';
import AirportShuttle from './components/transport/AirportShuttle';
import StepThree from './components/StepThree';
import {
  createCartWithParticipant,
  updateCart,
  updateCartParticipant,
} from './reducers/cart';
import {
  PROGRAM_TYPES,
  addExistentProducts,
  setForcedRefundable,
} from './reducers/form';
import GTMService, { TYPES } from './utils/gtm';
import API from './utils/api';
//import { getIsAdult, getDateFromString, isEmail } from './utils/helpers';
import { getIsAdult, isEmail } from './utils/helpers';

const gtm = new GTMService();
const api = new API();

window.checktimer = null;
window.messagetimer = null;
window.infomessagesnum = 0;
window.disableredirect = 0;
window.locked = false;

function App({
  retargetingData,
  repData,
  form,
  cartId,
  cartPrice,
  createCartWithParticipant,
  updateCart,
  updateCartParticipant,
  addExistentProducts,
  setForcedRefundable,
}) {
  const settings = useContext(SettingsContext);
  const [secondaryPositions, setSecondaryPositions] = useState([]);
  const step2Ref = useRef(null);
  //const stepConcentrationsRef = useRef(null);
  const stepExtrasRef = useRef(null);
  const stepFinalRef = useRef(null);
  const isAdult = getIsAdult(form.camper.age);
  const sport = settings.sport || form.sport;
  const businessType = settings.businessType || form.businessType;

  // Does not need to change, stays the same and comes from app retargeting or state hydration
  const initialDate = useMemo(
    () => retargetingData.date || form.programPeriod,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Does not need to change, stays the same and comes from state hydration
  const initialBirthdate = useMemo(
    () => form.camper.birthdate,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Does not need to change, stays the same and comes from state hydration
  /*
  const initialRefundable = useMemo(
    () => form.refundable,
    []
  );
  */
  var initialRefundable = 'Flexible';
  if(window.price_type !== 'undefined'){
    if(window.price_type === 'Refundable'){
      initialRefundable = 'Refundable';
    }
  }

  // console.log('[App.js] - settings', settings);
  // console.log('[App.ks] - form', form);

  // Initial cart creation and default participant
  // When there is a preloaded state, we need to add products one by one
  useEffect(() => {
    const init = async () => {
      gtm.trackChange(TYPES.OR_CAMPER_ADD);

      await createCartWithParticipant({
        email: settings.email,
        gender: retargetingData.gender,
        age: retargetingData.age,
      });

      // gtm.trackChange(TYPES.OR_CAMPER_ADDED);

      addExistentProducts();
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    createCartWithParticipant,
    retargetingData.age,
    retargetingData.gender,
    settings.email,
    updateCart,
    addExistentProducts,
  ]);

  useEffect(() => {
    api
      .fetchPositions(encodeURIComponent(sport))
      .then((res) => setSecondaryPositions(res.positions));
  }, [sport]);

  /*
  const sizesMapping = (size) => {
    var sizes = [];
    sizes['Youth S'] = "Youth Small";
    sizes['Youth M'] = "Youth Medium";
    sizes['Youth L'] = "Youth Large";
    sizes['Youth XL'] = "Youth XLarge";
    sizes['Adult S'] = "Adult Small";
    sizes['Adult M'] = "Adult Medium";
    sizes['Adult L'] = "Adult Large";
    sizes['Adult XL'] = "Adult XLarge";
    sizes['Adult XXL'] = "Adult XXLarge";
    for (var key in sizes) {
      if(sizes[key] === size){
        return key;
      }
    }
    return size;
  };
  */

  // XXX Due to some events (cov-19), we want to add all line items as refudanble
  /*useEffect(() => {

    if (!process.env.REACT_APP_DEFAULT_REFUNDABLE_DATE_LIMIT) {
      return;
    }

    setForcedRefundable(
      getDateFromString(process.env.REACT_APP_DEFAULT_REFUNDABLE_DATE_LIMIT) >
        new Date()
    );
  }, [setForcedRefundable]);*/

  // Step one when customer fills in boarding, birthdate and gender
  const completedStep1 = useMemo(() => {
    console.log('completedStep1', form.boarding, form.camper.birthdate, form.camper.gender, form.camper.position, form.isposition, form.issecondaryposition);

    if(form.isposition && form.issecondaryposition){
      return !!(
        sport !== null &&
        form.boarding !== null &&
        form.camper.birthdate &&
        form.camper.gender &&
        ((form.camper.position && form.camper.position !== 'Default') && form.camper.secondaryPositionName)
      );
    } else if(form.isposition || form.issecondaryposition){
      return !!(
        sport !== null &&
        form.boarding !== null &&
        form.camper.birthdate &&
        form.camper.gender &&
        ((form.camper.position && form.camper.position !== 'Default') || form.camper.secondaryPositionName)
      );
    } else {
      return !!(
        sport !== null &&
        form.boarding !== null &&
        form.camper.birthdate &&
        form.camper.gender
      );
    }
  }, [
    sport,
    form.boarding,
    form.camper.birthdate,
    form.camper.gender,
    form.camper.position,
    form.camper.secondaryPositionName,
    form.isposition,
    form.issecondaryposition,
  ]);
  console.log('completedStep1', completedStep1);
  console.log('completedStep1', form);

  // Step two when customer select N >=1 camps, with weeks equal the type length, or modal input
  const completedStep2 = useMemo(() => {
    const count = Object.keys(form.selectedCampOptions).length;

    console.log('completed Step2 check0',count);
    console.log('completed Step2 check1',form.selectedCampOptions);

    if (form.programType !== PROGRAM_TYPES.WEEKLY_CAMP) {
      return count > 0;
    }

    console.log('completed Step2 check2',form.programType);
    console.log('completed Step2 check3',form.programLengthInWeeks);

    return count > 0 && count >= form.programLengthInWeeks;
  }, [form.selectedCampOptions, form.programType, form.programLengthInWeeks]);

  const hasConcentrationWeeks = useMemo(
    () =>
      Object.values(form.selectedCampOptions).filter(
        (c) => !!c.hasConcentrationWeeks
      ).length > 0,
    [form.selectedCampOptions]
  );

  // Concentrations is an intermediary step, which should be completed before showing extras and final step
  const completedConcentrationsStep = useMemo(() => {

    if (!hasConcentrationWeeks || form.skipConcentrations) {
      return true;
    }

    return (
      form.concentrationsDataLength !== null &&
      Object.keys(form.selectedConcentrationOptions).length >=
        form.concentrationsDataLength
    );
  }, [
    hasConcentrationWeeks,
    form.skipConcentrations,
    form.concentrationsDataLength,
    form.selectedConcentrationOptions,
  ]);

  console.log('completed Step2',completedStep2);
  console.log('completed ConcentrationsStep',completedConcentrationsStep);

  // Final step
  const completedStep3 = useMemo(() => {
    if (typeof form.refundable !== 'boolean') {
      //return false;
    }

    // Email validation
    if (!!form.camper.email && !isEmail(form.camper.email)) {
      return false;
    }

    if (!!form.parent.email && !isEmail(form.parent.email)) {
      return false;
    }
    // End email validation

    const skipPositions =
      form.camper.position === null || form.camper.position !== 'Default' || secondaryPositions.length === 0;

    const keys = Object.keys(form.camper).filter((k) =>
      skipPositions
        ? k !== 'shortSize' &&
          k !== 'secondaryPosition' &&
          k !== 'secondaryPositionName'
        : k !== 'shortSize'
    );

    console.log('keys:', keys);

    if (isAdult) {
      return keys.every((key) => !!form.camper[key]);
    }

    const youngCamperKeysToCheck = keys.filter(
      (k) => k !== 'phoneNumber' && k !== 'email'
    );

    const parentKeysToCheck = Object.keys(form.parent).filter(
      (k) => k !== 'country' && k !== 'zipcode'
    );

    var checkresult = (
      youngCamperKeysToCheck.every((key) => !!form.camper[key]) &&
      parentKeysToCheck.every((key) => !!form.parent[key])
    );
    console.log('checkresult:', checkresult);
    return checkresult;
  }, [form.camper, form.parent, form.refundable, isAdult, secondaryPositions]);

  const currentStep = useMemo(() => {
    if (completedStep3) {
      return 4;
    }
    if (completedStep2 && completedConcentrationsStep) {
      return 3;
    }
    if (completedStep2) {
      return 2;
    }
    if (completedStep1) {
      return 1;
    }
    return 0;
  }, [
    completedStep1,
    completedStep2,
    completedConcentrationsStep,
    completedStep3,
  ]);

  useEffect(() => {
    const readyForCheckout =
      completedStep1 &&
      completedStep2 &&
      completedConcentrationsStep &&
      completedStep3;

    if (typeof window.reactAppUpdate === 'function') {
      window.reactAppUpdate({
        readyForCheckout: readyForCheckout,
        price: cartPrice,
        state: form,
        step: currentStep,
        secondaryPositions: secondaryPositions,
      });
    }

    // Update cart with camper (participant) and parent (cart) when step 3
    // is finished and expose react app finsihed
    if (readyForCheckout) {
      window.reactAppFinish = async (linkerParams) => {

        console.log('Check if all fetch finished....');

        //var bookingmessage = document.getElementById('booking-message');
        var fvaoverlay = document.getElementById('fvaoverlay');
        var products = window.newcart.cart.participants[0].products;

        // Recheck shopify froducts
        /*
        var products_ids = [];
        for (let product of products) {
          products_ids.push(product.id);
        }
        var shopify_products_list_out = [];
        for (let shopify_product of window.newcart.products) {
          console.log(shopify_product);
          var shopify_product_found = false;
          for (let sproduct of shopify_product) {
            if(products_ids.includes(sproduct.product_id)){
              shopify_product_found = true;
              console.log('Found', shopify_product);
            }
          }
          if(shopify_product_found){
            shopify_products_list_out.push(shopify_product);
          }
        }
        if(shopify_products_list_out.length){
          window.newcart.products = shopify_products_list_out;
        }
        console.log('Check Products', window.newcart);
        */

        // Add messages while wait for checking products...
        var infomessages = ['Confirming reservation', 'Adding to cart', 'Please wait...'];
        window.messagetimer = window.setTimeout(function () {
          if (window.infomessagesnum < 3){
            fvaoverlay.innerHTML = '<span style="display: block;position: absolute;top: calc(50% + 0px);left: calc(50% + 0px);transform: translate(-50%, -50%); width: 200px;text-align: center;" class="add-to-cart-message">'+infomessages[window.infomessagesnum]+'</span>';
            console.log('messagetimer', window.infomessagesnum, infomessages[window.infomessagesnum]);
            window.infomessagesnum = window.infomessagesnum + 1;
          }
        }, 1000);

        var shopify_products = window.newcart.products;
        if(products.length !== shopify_products.length){
          console.log('products', products.length);
          console.log('shopify_products', shopify_products.length);
          console.log('products list', products);
          console.log('shopify_products list', shopify_products);
          //bookingmessage.innerText="Still wait for products fetch...";
          //bookingmessage.classList.remove('hide-all');
          fvaoverlay.style.display = 'block';
          window.checktimer = window.setTimeout(function () {
            window.reactAppFinish(linkerParams);
          }, 1000);
          return false;
        }

        fvaoverlay.style.display = 'none';
        window.clearTimeout(window.checktimer);
        window.clearTimeout(window.messagetimer);

        // Get Shopify API Cart content and check for participants
        /*
        var participants = [];
        var ParticipantId = 0;
        const shopify_cart_content = await api.getShopifyCart();
        console.log('Shopify Cart:', shopify_cart_content);
        const shopify_cart_participants = shopify_cart_content.attributes.participants;
        if(shopify_cart_participants){
          participants = JSON.parse(shopify_cart_participants);
          console.log('participants check:', participants);
          if(participants.length){
            var last_participant_id = participants[participants.length-1].id;
            last_participant_id = last_participant_id.split('_');
            if(last_participant_id[1]){
              console.log('last_participant_id', last_participant_id[1]);
              ParticipantId = parseInt(last_participant_id[1])+1;
            }
          }
        }
        */
        var participants = [];
        const shopify_cart_content = await api.getShopifyCart();
        console.log('Shopify Cart:', shopify_cart_content);
        const shopify_cart_participants = shopify_cart_content.attributes.participants;
        if(shopify_cart_participants){
          participants = JSON.parse(shopify_cart_participants);
          console.log('participants check:', participants);
        }
        const ParticipantId = Date.now();
        console.log('ParticipantId:', ParticipantId);

        var gender = form.camper.gender;
        if(gender === 'Male') gender = 'male';
        if(gender === 'Female') gender = 'female';

        // Updating cart with camper data
        const participant = {
          id: 'participant_'+ParticipantId,
          age: form.camper.age,
          //dob: getDateFromString(form.camper.birthdate).getTime() / 1000,
          dob: form.camper.birthdate,
          email: form.camper.email || form.parent.email, // Tweak to not fail API where email is required
          first_name: form.camper.firstName,
          last_name: form.camper.lastName,
          gender: gender,
          phone: form.camper.phoneNumber || form.parent.phoneNumber, // Same as above
          position: form.camper.secondaryPosition,
          positionName: form.camper.secondaryPositionName,
          preferred_shirt_size: form.camper.shirtSize,
          preferred_short_size: form.camper.shortSize,
          shirt_size: form.camper.shirtSize,
          marketing_data: window.marketing_data,
        };

        var shirt_size = form.camper.shirtSize;
        if(shirt_size){
          shirt_size = shirt_size.replace('_', ' ');
        }
        console.log('shirt_size:', shirt_size);

        console.log('form:', form.camper);
        console.log('participant:', participant);

        //const participant_info = await updateCartParticipant(participant);
        //console.log('participant_info:', participant_info);

        // Updating cart with parent data
        // if Age is 18 under, use parent fields
        // if Age is 19 above, use camper fields
        const key = isAdult ? 'camper' : 'parent';
        const props = {
          email: form[key].email,
          first_name: form[key].firstName,
          last_name: form[key].lastName,
          contact_number: form[key].phoneNumber,
          address: {
            country: form.parent.country,
            zipcode: form.parent.zipcode,
          },
        };

        if (repData.email && repData.data) {
          props.representative_email = repData.email;
          props.representative_data = repData.data;
        }

        if(window.repEmail){
          props.representative_email = window.repEmail;
        }

        console.log('updateCart:', props);

        //await updateCart(props);

        gtm.trackChange(TYPES.OR_CART_APPROVED);

        const cart_content = window.newcart;
        console.log('Cart:', cart_content);

        var items = [];
        const refundable = cart_content.cart.refundable;
        for (let products of cart_content.products) {
          var shopify_id = 0;
          var quantity = 1;
          var type = '';
          var product_id = 0;
          //var shirt_size_shopify_id = false;
          for (let product of products) {
            if(product.type_key){
              var type_key_exist = false;
              const type_key = product.type_key;
              if(type_key.indexOf('airport_') !== -1) type_key_exist = true;
              if(refundable === 'Flexible' && product.type_key === "flexible"){
                shopify_id = product.shopify_id;
                quantity = product.quantity;
                type = product.product_type;
                product_id = product.product_id;
              } else if(refundable === 'Refundable' && product.type_key === "refundable"){
                shopify_id = product.shopify_id;
                quantity = product.quantity;
                type = product.product_type;
                product_id = product.product_id;
              } else if(refundable === 'Normal' && product.type_key === "non_refundable"){
                shopify_id = product.shopify_id;
                quantity = product.quantity;
                type = product.product_type;
                product_id = product.product_id;
              } else if(product.type_key === "attribute") {
                shopify_id = product.shopify_id;
                quantity = product.quantity;
                type = product.product_type;
                product_id = product.product_id;
              } else if(product.product_type === "concentration") {
                shopify_id = product.shopify_id;
                quantity = product.quantity;
                type = product.product_type;
                product_id = product.product_id;
              } else if(product.product_type === "shopify_gear") {
                shopify_id = product.shopify_id;
                quantity = product.quantity;
                type = "gear";
                product_id = product.product_id;
              } else if(product.product_type === "gear-upsell" || product.product_type === "excursion" || product.product_type === "room_upgrade") {
                for (let products_upsell of window.newcart.cart.participants[0].products) {
                  if(products_upsell.id === product.capacity_id){
                    shopify_id = product.shopify_id;
                    quantity = product.quantity;
                    type = product.product_type;
                    product_id = product.product_id;
                  }
                }
              } else if(product.product_type === "gear") {
                /*
                if(!shirt_size_shopify_id){
                  shopify_id = product.shopify_id;
                }
                if(shirt_size === sizesMapping(product.shopify_data.title)){
                  shopify_id = product.shopify_id;
                  shirt_size_shopify_id = true;
                  console.log('shirt_size shopify_id:',shopify_id);
                }
                */
                shopify_id = product.shopify_id;
                quantity = product.quantity;
                type = product.product_type;
                product_id = product.product_id;
              } else if(type_key_exist) {
                shopify_id = product.shopify_id;
                quantity = product.quantity;
                //type = product.product_type;
                type = 'airport';
                product_id = product.product_id;
              }
            }
          }
          if(shopify_id){
            var shopify_product = '';
            var symfony_products = cart_content.cart.participants[0].products;
            for (let symfony_product of symfony_products) {
              if(symfony_product.id === product_id){
                shopify_product = symfony_product;
              }
            }
            var properties = {};
            if(type === "camp"){
              var product = shopify_product;
              var strArray=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              let StartDate = new Date(product.product.capacity_start_date);
              var dd = StartDate.getDate();
              var mm = strArray[StartDate.getMonth()];
              var yyyy = StartDate.getFullYear();
              var capacity_start_date = mm + ' ' + dd + ', ' + yyyy;
              let EndDate = new Date(product.product.capacity_end_date);
              var dd1 = EndDate.getDate();
              var mm1 = strArray[EndDate.getMonth()];
              var yyyy1 = EndDate.getFullYear();
              var capacity_end_date = mm1 + ' ' + dd1 + ', ' + yyyy1;
              properties = {
                // Camp
                'Business Type': product.product.business_type,
                'Sport': product.product.sport,
                'Refundable': (product.refundable) ? "Refundable" : "Non-Refundable",
                'Length': product.product.length,
                'Length Weeks': product.product.length_weeks,
                'Program Type': product.product.program_type,
                'Start Date': capacity_start_date,
                'End Date': capacity_end_date,
                'Age Range': product.product.age_range,
                'Group': product.product.group,
                'Secondary Group': product.product.secondary_group,
                // Participant
                'Participant First Name': form.camper.firstName,
                'Participant Last Name': form.camper.lastName,
                'Participant Gender': form.camper.gender,
                'Participant Email': form.camper.email || form.parent.email,
                'Participant Age': form.camper.age,
                'Participant Position': form.camper.secondaryPositionName,
                'Participant Shirt Size': form.camper.shirtSize,
                // Guardian
                'Guardian First Name': form.parent.firstName,
                'Guardian Last Name': form.parent.lastName,
                'Guardian Email': form.parent.email,
                'Guardian Phone': form.parent.phoneNumber,
                // Participant DATA
                'participant_data': JSON.stringify(cart_content.cart.participants[0]),
              };
              properties.product = JSON.stringify(shopify_product);
              properties.participant_id = "participant_"+ParticipantId;
              if(product.refundable === 'Flexible' && product.product.price_flexible){
                properties.Refundable = 'Flexible';
              } else if (product.refundable === 'Refundable' && product.product.price_refundable){
                properties.Refundable = 'Refundable';
              } else {
                properties.Refundable = 'Normal';
              }
            } else if(type === "concentration") {
              properties = {
                // Participant
                'Participant First Name': form.camper.firstName,
                'Participant Last Name': form.camper.lastName,
                'Participant Gender': form.camper.gender,
                'Participant Email': form.camper.email || form.parent.email,
                'Participant Age': form.camper.age,
                'Participant Position': form.camper.secondaryPositionName,
                'Participant Shirt Size': form.camper.shirtSize,
                // Guardian
                'Guardian First Name': form.parent.firstName,
                'Guardian Last Name': form.parent.lastName,
                'Guardian Email': form.parent.email,
                'Guardian Phone': form.parent.phoneNumber,
                // Participant DATA
                'participant_data': JSON.stringify(cart_content.cart.participants[0]),
              };
              properties.product = JSON.stringify(shopify_product);
              properties.participant_id = "participant_"+ParticipantId;
            } else if(type === "airport") {
              properties.bundle = "false";
              properties.product = JSON.stringify(shopify_product);
              properties.participant_id = "participant_"+ParticipantId;
            } else {
              properties.bundle = "false";
              properties.participant_id = "guest";
              console.log('shopify_product',shopify_product);
              if(shopify_product.product !== undefined && shopify_product.product.capacity_available !== undefined && parseInt(shopify_product.product.capacity_available)>0){
                properties.participant_id = "participant_"+ParticipantId;
              }
              properties.product = JSON.stringify(shopify_product);
            }
            var item = {
                quantity: quantity,
                id: shopify_id,
                properties: properties
            };
            items.push(item);
          }
        }

        participants.push(participant);
        var attributes = {};
        attributes.customer = JSON.stringify(props);
        attributes.participants = JSON.stringify(participants);

        let productData = {
          'items': items
        };
        console.log('productData Data:', productData);
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(productData)
        })
        .then(async (response) => {
          console.log('Products added to cart info:', response);
          if(response.status === 200){

            // Set promocode
            if(window.promocode){
              const promocode = await api.setShopifyPromocode(window.promocode);
              console.log('Symfony Cart:', promocode);
            }

            // Add participants to cart
            let participantsData = {
              'attributes': attributes
            };
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(participantsData)
            })
            .then(response => {
              console.log('Participants added to cart info:', response);
              if(window.disableredirect === 1) return false;
              window.location.href = '/cart';
            })
            .catch((error) => {
              console.error('Error add participants to cart:', error);
            });

          }
        })
        .catch((error) => {
          console.error('Error add products to cart:', error);
        });

        /*
        // 1. Get Symfony API Cart content
        const cart_content = await api.getCart(cartId);
        console.log('Symfony Cart:', cart_content);

        // 2. Add Products to cart
        var items = [];
        for (let shopify_participant of cart_content.cart.participants) {
          for (let shopify_product of shopify_participant.products) {
            var shopify_product_id = 0;
            for (let shopify_products of cart_content.shopify) {
              if(shopify_products.catalog_id === shopify_product.product.id) {
                shopify_product_id = shopify_products.shopify_id;
              }
            }
            var properties = {};
            if(shopify_product.type === "camp"){
              var product = shopify_product;
              var strArray=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              let StartDate = new Date(product.product.capacity_start_date);
              var dd = StartDate.getDate();
              var mm = strArray[StartDate.getMonth() + 1];
              var yyyy = StartDate.getFullYear();
              var capacity_start_date = mm + ' ' + dd + ', ' + yyyy;
              let EndDate = new Date(product.product.capacity_end_date);
              var dd1 = EndDate.getDate();
              var mm1 = strArray[EndDate.getMonth() + 1];
              var yyyy1 = EndDate.getFullYear();
              var capacity_end_date = mm1 + ' ' + dd1 + ', ' + yyyy1;
              properties = {
                // Camp
                'Business Type': product.product.business_type,
                'Sport': product.product.sport,
                'Refundable': (product.refundable) ? "Refundable" : "Non-Refundable",
                'Length': product.product.length,
                'Length Weeks': product.product.length_weeks,
                'Program Type': product.product.program_type,
                'Start Date': capacity_start_date,
                'End Date': capacity_end_date,
                'Age Range': product.product.age_range,
                'Group': product.product.group,
                'Secondary Group': product.product.secondary_group,
                // Participant
                'Participant First Name': form.camper.firstName,
                'Participant Last Name': form.camper.lastName,
                'Participant Gender': form.camper.gender,
                'Participant Email': form.camper.email || form.parent.email,
                'Participant Age': form.camper.age,
                'Participant Position': form.camper.position,
                'Participant Shirt Size': form.camper.shirtSize,
                // Guardian
                'Guardian First Name': form.parent.firstName,
                'Guardian Last Name': form.parent.lastName,
                'Guardian Email': form.parent.email,
                'Guardian Phone': form.parent.phone,
                // Participant DATA
                'participant_data': JSON.stringify(shopify_participant),
              };
              properties.product = JSON.stringify(shopify_product);
              properties.participant_id = "participant_"+ParticipantId;
            } else {
              properties.bundle = "false";
              properties.participant_id = "guest";
              properties.product = JSON.stringify(shopify_product);
            }
            var item = {
                quantity: shopify_product.quantity,
                id: shopify_product_id,
                properties: properties
            };
            items.push(item);
          }
        }
        //items.reverse();

        participants.push(participant);
        var attributes = {};
        attributes.customer = JSON.stringify(props);
        attributes.participants = JSON.stringify(participants);
        let formData = {
          'attributes': attributes,
          'items': items
        };
        console.log('Cart Data:', formData);
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          console.log('Product added to cart info:', response);
          window.location.href = '/cart';

        })
        .catch((error) => {
          console.error('Error add to cart:', error);
        });
        */

        /*
        // Now we should determine size, another API call that should not happend here :(
        const cart_result = await api.determineSize(cartId);
        console.log('cart_result:', cart_result);

        const params = {
          order: cartId,
          linkerParams,
        };
        //console.log('params.edit_url:', params);
        try {
          const storage = await api.setStorage(form);
          const base = `${window.location.origin}${window.location.pathname}`;
          const query = qs.stringify({
            token: storage.token,
          });
          params.edit_url = `${base}?${query}${window.location.hash}`;
          //console.log('params.edit_url:', params.edit_url);
        } catch (e) {
          console.error('Editing will not work later, storage failed!');
        }

        const redirectUrl = `${settings.redirectUrl}?${qs.stringify(params)}`;
        console.log('redirectUrl:', redirectUrl);
        if (process.env.NODE_ENV === 'production') {
          window.location.href = redirectUrl;
        }
        */
      };
    }
  }, [
    completedStep1,
    completedStep2,
    completedConcentrationsStep,
    completedStep3,
    currentStep,
    form,
    cartPrice,
    cartId,
    settings.redirectUrl,
    updateCartParticipant,
    updateCart,
    isAdult,
    repData,
    secondaryPositions
  ]);

  if (!cartId) {
    return null;
  }

  const bundleCamps = Object.values(form.selectedCampOptions).filter(
    (c) => c.product.is_bundle_package
  );

  console.log('locked0:', form);

  return (
    <div>
      <div id="step-1">
        <StepOne
          initialAge={initialBirthdate ? null : retargetingData.age}
          initialBirthdate={initialBirthdate}
          initialBoarding={retargetingData.boarding}
          initialGender={retargetingData.gender}
          secondaryPositions={secondaryPositions}
          businessType={businessType}
          sport={sport}
          locked={form.locked}
        />
      </div>

      <div ref={step2Ref} id="step-2" data-aos="fade-up">
        {completedStep1 && (
          <Step title="Step 2">
            <Step.Sub title="Choose your camp">
              <StepTwo
                initialDate={initialDate}
                initialSecondaryGroup={retargetingData.secondaryGroup}
                sport={sport}
                businessType={businessType}
                defaultRefundable={initialRefundable}
              />
            </Step.Sub>
          </Step>
        )}
      </div>

      {/*
      <div
        ref={stepConcentrationsRef}
        id="step-concentrations"
        data-aos="fade-up"
        style={{display: 'none' }}
      >
        {completedStep2 && hasConcentrationWeeks && (
          <Specializations
            title="Choose training specializations"
            sport={sport}
            businessType={businessType}
          />
        )}
      </div>
      */}

      <div ref={stepExtrasRef} id="step-extras" data-aos="fade-up">
        {completedStep2 && (
          <Fragment>
            {completedConcentrationsStep && !isAdult && (
              <RoomUpgrades title="Room upgrades" />
            )}

            {completedConcentrationsStep && bundleCamps.length > 0 && (
              <Step title="+" specialclasses="included-items">
                <Step.Sub title="Included With Your Camp">
                  <div
                    id="content"
                    data-number={bundleCamps.length}
                    data-boarding={form.boarding ? 'Yes' : 'No'}
                    data-age={form.camper.age}
                    data-gender={form.camper.gender}
                    data-position={form.camper.position}
                  >
                    <div className="extras">
                      <div className="extras__list">
                        <div className="card">
                          <div className="card__header">
                            <h5 className="card__title">
                              UNDER ARMOUR & THERABODY GEAR KIT
                            </h5>
                            <div className="card__price">
                              <div className="card__price-amount">Included</div>
                              <div className="card__price-label">
                                ${399 * bundleCamps.length} value
                              </div>
                            </div>
                          </div>
                          <div className="card__body">
                            <div className="extras-item__body">
                              {form.camper.gender === 'Male' ? (
                                <img
                                  src="https://www.imgacademy.com/sites/default/files/22-gear-kit-mens.png"
                                  width="150"
                                  alt="Under Armour Elite Package - Male"
                                />
                              ) : (
                                <img
                                  src="https://www.imgacademy.com/sites/default/files/22-gear-kit-womens.png"
                                  width="150"
                                  alt="Under Armour Elite Package - Female"
                                />
                              )}
                              <label className="field__label">
                                <select
                                  name="UNDER ARMOUR & THERABODY GEAR KIT"
                                  disabled
                                >
                                  <option value={bundleCamps.length} selected>
                                    {bundleCamps.length}
                                  </option>
                                </select>
                              </label>
                              <p>
                                Exclusive gear kit includes: 3 performance
                                t-shirts, 3 pairs of shorts, and 1 Theragun Mini
                                Massager.
                              </p>
                              <p>
                                Your camp selections mean you will receive{' '}
                                {1 * bundleCamps.length} gear kit(s).
                              </p>
                            </div>
                            <button
                              className="extras-item__button field__input--selected"
                              disabled
                            >
                              Included
                            </button>
                          </div>
                        </div>
                        {form.boarding ? (
                          <div className="card">
                            <div className="card__header">
                              <h5 className="card__title">LAUNDRY BAG</h5>
                              <div className="card__price">
                                <div className="card__price-amount">
                                  Included
                                </div>
                                <div className="card__price-label">
                                  ${15 * 3 * bundleCamps.length} value
                                </div>
                              </div>
                            </div>
                            <div className="card__body">
                              <div className="extras-item__body">
                                <img
                                  src="https://www.imgacademy.com/sites/default/files/laundry-bag.png"
                                  width="150"
                                  alt="Laundry Bag"
                                />
                                <label className="field__label">
                                  <select name="Laundry Service" disabled>
                                    <option
                                      value={3 * bundleCamps.length}
                                      selected
                                    >
                                      {3 * bundleCamps.length}
                                    </option>
                                  </select>
                                </label>
                                <p>
                                  One 10-pound laundry bag per week of stay for
                                  clothes to be dropped off at designated
                                  laundry pick-up locations in each dorm,
                                  laundered and delivered back to athlete's
                                  room. Laundry is serviced once per week. Each
                                  laundry bag is 1-time use only.
                                </p>
                                <p>
                                  Your camp selections mean you will receive{' '}
                                  {3 * 1 * bundleCamps.length} laundry bag(s).
                                </p>
                              </div>
                              <button
                                className="extras-item__button field__input--selected"
                                disabled
                              >
                                Included
                              </button>
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>
                </Step.Sub>
              </Step>
            )}

            <Excursions
              title="Off-campus excursions"
              isVisible={completedConcentrationsStep}
            />
            <Gears
              title="Enhance your camp experience"
              isVisible={completedConcentrationsStep}
            />
            {/* <Essentials
              title="Camp essentials"
              isVisible={completedConcentrationsStep}
            /> */}

            {completedConcentrationsStep && (
              <Upsells title="Club fittings" sport={sport} />
            )}

            {completedConcentrationsStep && (
              <Step title="+">
                <Step.Sub title="Airport Shuttle Service">
                  <div className="airport">
                    <AirportShuttle />
                  </div>
                </Step.Sub>
              </Step>
            )}
          </Fragment>
        )}
      </div>

      <div ref={stepFinalRef} id="step-final" data-aos="fade-up">
        {completedStep2 && completedConcentrationsStep && (
          <Step title="Final Step">
            <Step.Sub title="Enter Camper Information">
              <StepThree
                defaultRefundable={initialRefundable}
                secondaryPositions={secondaryPositions}
              />
            </Step.Sub>
          </Step>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    form: state.form,
    cartPrice: (state.cart.cart && state.cart.cart.price_total) || 0,
    cartId: state.cart.cart ? state.cart.cart.id : null,
  };
};

const mapDispatchToProps = (dispatch) => ({
  createCartWithParticipant: (params) =>
    dispatch(createCartWithParticipant(params)),
  updateCart: (params) => dispatch(updateCart(params)),
  updateCartParticipant: (params) => dispatch(updateCartParticipant(params)),
  addExistentProducts: () => dispatch(addExistentProducts()),
  setForcedRefundable: (value) => dispatch(setForcedRefundable(value)),
});

App.propTypes = {
  settings: PropTypes.shape({
    contentPath: PropTypes.string,
    sport: PropTypes.string,
    businessType: PropTypes.string,
  }),
  retargetingData: PropTypes.shape({
    boarding: PropTypes.string,
    age: PropTypes.string,
    gender: PropTypes.string,
  }),
  repData: PropTypes.shape({
    email: PropTypes.string,
    data: PropTypes.string,
  }),
  form: PropTypes.object.isRequired,
  cartPrice: PropTypes.number.isRequired,
  cartId: PropTypes.number,
  createCartWithParticipant: PropTypes.func.isRequired,
  updateCart: PropTypes.func.isRequired,
  updateCartParticipant: PropTypes.func.isRequired,
  addExistentProducts: PropTypes.func.isRequired,
};

App.displayName = 'App';

export default connect(mapStateToProps, mapDispatchToProps)(App);
